import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=3409b53a&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
import style0 from "./activity.vue?vue&type=style&index=0&id=3409b53a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409b53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3409b53a')) {
      api.createRecord('3409b53a', component.options)
    } else {
      api.reload('3409b53a', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=3409b53a&scoped=true", function () {
      api.rerender('3409b53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/seckill/seckillActivity/activity.vue"
export default component.exports